import { Box, CircularProgress, Typography } from "@mui/material"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RoleIdText } from "./Atom"
import { useResponseHandle } from "../../../../../../hooks"
import AdminAPI from "../../../../../../../api/admin"
import { getTokenLocal } from "../../../../../../../helper/utils"
import { useNavigate } from "react-router-dom"
import { setGaData } from "../../../../../../redux/slices/usersSlice"

const adminAPI = new AdminAPI()
function GroupAdminListTab({ group_sk }: any) {
  const token: any = getTokenLocal()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const allGA = useSelector((state: any) => {
    return state.users.gaData
  })

  const fetchAllGroupAdmins = async () => {
    const response = await adminAPI.getAllGa(token, group_sk)
    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      setIsLoading(false)
      if (result?.statusCode == 200) {
        dispatch(setGaData(result?.data))
      }
    } else {
      setIsLoading(false)
      navigate("/auth")
    }

    return result
  }

  useEffect(() => {
    allGA.length === 0 && setIsLoading(true)
    fetchAllGroupAdmins()
  }, [group_sk])

  return (
    <>
      {!isLoading ? (
        allGA?.length > 0 ? (
          <Box
            sx={{
              width: "30%",
              height: "100%",
              border: "1px solid #E3E3E3",
            }}
          >
            {allGA?.map((ga: any, itemIndex: any) => {
              return (
                <li
                  key={itemIndex}
                  style={{
                    listStyle: "none",
                    padding: "22px 20px",
                    fontSize: "14px",
                    color: "#000",
                    fontWeight: "bold",
                    textTransform: "capitalize",
                    borderBottom: "1px solid #E5E5E5",
                  }}
                >
                  {ga?.name}
                  <RoleIdText>{ga.role_display_name}</RoleIdText>
                </li>
              )
            })}
          </Box>
        ) : (
          <Typography sx={{ padding: "2rem" }}>
            No Group Admins assigned
          </Typography>
        )
      ) : (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            // border: "1px solid red"
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </>
  )
}

export default GroupAdminListTab
